<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12">
        <app-editor ref="direction" v-model="crud.description" />
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-if="title === 'Retelling'"
          v-model="crud.question_group.questions[0].question_file"
          label="Audio file"
        >
          <template
            v-slot:selection
            v-if="typeof crud.question_group.questions[0].question_file === 'string'"
          >
            You already saved a file. Click to save a new one...
          </template>
        </v-file-input>
      </v-col>
      <v-col cols="12">
        <app-editor ref="description" v-model="crud.question_group.questions[0].content" />
      </v-col>

      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto">
        Save
      </v-btn>
    </v-row>
  </v-form>
</template>
<script>
import { getHomeworkById } from "@/api/api";
import homeworkMixin from "@/mixins/homeworkMixin";
import Editor from "../../../Utils/Editor.vue";

export default {
  components: {
    appEditor: Editor,
  },
  props: {
    title: {
      required: false,
      default: "Retelling",
      type: String,
    },
  },
  data() {
    return {
      crud: {
        question_group: {
          questions: [
            {
              title: this.title,
              content: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "Homework details here...",
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
      },
    };
  },
  mixins: [homeworkMixin],
  async mounted() {
    if (this.data.uuid) {
      const response = await getHomeworkById(this.data.uuid);
      const crud = {
        ...response.data,
        description: JSON.parse(response.data.description),
      };
      this.$refs.direction.setContent(crud.description);
      this.$refs.description.setContent(JSON.parse(crud.question_group.questions[0].content));

      this.crud = crud;
    } else if (this.data) {
      let description = {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: "Directions here...",
              },
            ],
          },
        ],
      };
      const data = this.data;
      data.question_group.questions = [
        {
          title: this.title,
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    type: "text",
                    text: "Homework details here...",
                  },
                ],
              },
            ],
          },
        },
      ];
      this.crud = {
        ...this.data,
        description,
      };
      this.$refs.direction.setContent(this.crud.description);
      this.$refs.description.setContent(this.crud.question_group.questions[0].content);
    }
  },
};
</script>
